import React, { lazy, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoutes } from "./utils/protected_routes";
import { useDispatch, useSelector } from "react-redux";
import { clearToast, setToast } from "./redux/reducers/toast_message";
import { ToastMessage } from "./components";

// Lazy loading the pages
const Login = lazy(() => import("./pages/login"));
const Dashboard = lazy(() => import("./pages/dashboard"));
const Report = lazy(() => import("./pages/report"));
const ProductManagement = lazy(() => import("./pages/product_management"));
const AddProduct = lazy(() => import("./pages/product_management/add_product"));
const UpdateProduct = lazy(() =>
  import("./pages/product_management/update_product")
);
const PrivacyPage = lazy(() => import("./pages/privacy"));
const DeleteAccount = lazy(() => import("./pages/delete-account"));
const ReferralPage = lazy(() => import("./pages/referral"));
const AddReferral = lazy(() => import("./pages/referral/add_referral"));
const UpdateReferral = lazy(() => import("./pages/referral/update_referral"));
const App = () => {
  const dispatch = useDispatch();
  const { isToast } = useSelector((state) => state.toast);

  useEffect(() => {
    if (isToast) {
      setTimeout(() => {
        dispatch(clearToast());
      }, 3000);
    }
  }, [isToast]);

  return (
    <>
      {/* Toast Message */}
      {isToast && <ToastMessage />}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/delete-account" element={<DeleteAccount />} />

        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/report" element={<Report />} />
          <Route path="/product" element={<ProductManagement />} />
          <Route path="/product/add" element={<AddProduct />} />
          <Route path="/product/update" element={<UpdateProduct />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route path="/referral/add" element={<AddReferral />} />
          <Route path="/referral/:id" element={<UpdateReferral />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;
